<div class="buttons">
  <slot />
</div>

<style>
  .buttons {
    user-select: none;
    padding-block: 1rem;
    margin-inline: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
  }
</style>
